"use strict";

exports.__esModule = true;
exports.DeviceCycleColorSource = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = require("styled-components");
var _Timeline = require("../../../Timeline");
var _TimelineSubscription = require("../../../Timeline/TimelineSubscription");
var _PlantStateActivities = require("../../../PlantStateActivities");
var _class, _DeviceCycleColorSource;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Current device cycle color source.
 * Supplies a color to children via a render prop.
 */
var DeviceCycleColorSource = exports.DeviceCycleColorSource = (0, _styledComponents.withTheme)(_class = (_DeviceCycleColorSource = /*#__PURE__*/function (_Component) {
  function DeviceCycleColorSource() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(DeviceCycleColorSource, _Component);
  var _proto = DeviceCycleColorSource.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      deviceUuid = _this$props.deviceUuid,
      theme = _this$props.theme,
      defaultColor = _this$props.defaultColor,
      children = _this$props.children;
    return /*#__PURE__*/_react["default"].createElement(_TimelineSubscription.TimelineSubscription, {
      timelineName: _Timeline.TIME_SERIES_CLASSIFICATION,
      isCurrent: true,
      query: {
        device: deviceUuid
      }
    }, function (packet) {
      if (packet != null && packet.value != null) {
        return children((0, _PlantStateActivities.getPlantStateColor)(theme, packet.value.state));
      }
      return children(defaultColor);
    });
  };
  return DeviceCycleColorSource;
}(_react.Component), _DeviceCycleColorSource.defaultProps = {
  theme: undefined
}, _DeviceCycleColorSource)) || _class;